import { useMemo } from 'react';
import { useFeatureFlag } from 'features/accessControl';
import { iframePaths } from '../utils';
import { iframePathFeatureFlagOverrides } from '../config';

/**
 * Returns iframe paths that should be shown in the iframe (paths not replaced by React views).
 * When a path's feature flag is enabled, the React view is shown instead.
 */
export function useActiveIframePaths(): string[] {
  const isItemsTableViewEnabled = useFeatureFlag('ItemsTableView');
  const isStylesTableViewEnabled = useFeatureFlag('StylesTableView');
  const flagMap: Record<string, boolean> = useMemo(
    () => ({
      ItemsTableView: isItemsTableViewEnabled,
      StylesTableView: isStylesTableViewEnabled,
    }),
    [isItemsTableViewEnabled, isStylesTableViewEnabled]
  );
  return useMemo(
    () =>
      iframePaths.filter(p => {
        const rule = iframePathFeatureFlagOverrides.find(r => r.path === p);
        return !rule || !flagMap[rule.featureFlag];
      }),
    [flagMap]
  );
}
